// Навигация суперадминки. Держим в одном месте, чтобы один раз поменять и
// получить обновления и в Sidebar, и в командной палитре (если появится).

import {
  LayoutDashboard,
  Building2,
  Store,
  Warehouse,
  Wallet,
  CreditCard,
  Smartphone,
  LifeBuoy,
  ShieldCheck,
  Tag,
  Settings,
  Images,
  UtensilsCrossed,
  MessageSquareText,
  Users,
  Handshake,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

export const NAV: NavItem[] = [
  { to: '/', label: 'Дашборд', icon: LayoutDashboard },
  { to: '/tenants', label: 'Арендаторы', icon: Building2 },
  { to: '/suppliers', label: 'Поставщики', icon: Store },
  { to: '/wholesalers', label: 'Оптовики', icon: Warehouse },
  { to: '/supplier-finance', label: 'Финансы пост.', icon: Wallet },
  { to: '/billing', label: 'Биллинг', icon: CreditCard },
  { to: '/managers', label: 'Менеджеры', icon: Handshake },
  { to: '/plans', label: 'Тарифы', icon: Tag },
  { to: '/devices', label: 'Устройства', icon: Smartphone },
  { to: '/support', label: 'Поддержка', icon: LifeBuoy },
  { to: '/audit', label: 'Аудит', icon: ShieldCheck },
  { to: '/settings', label: 'Настройки', icon: Settings },
];

// Витрина гостевого приложения People — отдельная группа в сайдбаре.
export const APP_NAV: NavItem[] = [
  { to: '/app/banners', label: 'Баннеры', icon: Images },
  { to: '/app/cuisines', label: 'Кухни', icon: UtensilsCrossed },
  { to: '/app/reviews', label: 'Отзывы', icon: MessageSquareText },
  { to: '/app/users', label: 'Пользователи', icon: Users },
];
